import { memo, useState } from 'react';
import { ChevronRightIcon } from '@page/icons';
import { Accordion, AccordionContent, AccordionItem, cn, IconButton, PageHeader } from '@page/ui';

interface CollapsibleSectionProps {
  defaultOpen?: boolean;
  title: React.ReactNode;
  children: React.ReactNode;
}

const CollapsibleSectionBase = ({ title, children, defaultOpen = true }: CollapsibleSectionProps) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div>
      <PageHeader
        className={cn('transition-padding', open ? 'pb-2' : 'pb-6 border-b border-border-default')}
        title={<h2 className="font-heading-2xl text-text-primary font-semibold">{title}</h2>}
        right={
          <IconButton onClick={() => setOpen(!open)}>
            <ChevronRightIcon
              className="size-5 transition-transform duration-200"
              style={{ transform: open ? 'rotate(90deg)' : 'rotate(0deg)' }}
            />
          </IconButton>
        }
      />

      <Accordion
        type="single"
        collapsible
        value={open ? 'collapsible' : ''}
        naked
        className={cn({ 'overflow-visible': open })}
      >
        <AccordionItem value="collapsible">
          <AccordionContent
            className="p-0"
            containerClassName="border-0 border-b border-border-default rounded-none pb-6 shadow-none overflow-visible"
          >
            {children}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export const CollapsibleSection = memo(CollapsibleSectionBase);
